/**
 * @license lucide-react v1.59.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.mjs';

const __iconData = {
  name: "code",
  size: 24,
  node: [
    ["path", { d: "m16 18 6-6-6-6", key: "eg8j8" }],
    ["path", { d: "m8 6-6 6 6 6", key: "ppft3o" }]
  ]
};
__iconData.node;
const Code = createLucideIcon(__iconData);

export { __iconData, Code as default };
//# sourceMappingURL=code.mjs.map
